/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { InfoItem } from '@molecules';
import { useMinisite } from '@api/hooks';

const Item = ({ className, module, previewImg, errors }) => {
  const minisiteQuery = useMinisite({ id: module.content.minisiteId });

  return (
    <InfoItem.WithError
      error={errors}
      className={className}
      size="large"
      image={previewImg}
      description={minisiteQuery?.minisite?.name || 'Minisite Library not found'}
    >
      Library
    </InfoItem.WithError>
  );
};

export default Item;
